/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import Reflux from 'reflux';
import { Button, Row, Col, message, Modal } from 'antd';
import { hashHistory, withRouter } from 'react-router';
import { DmsTab, TableView, AdvanceForm } from 'Components';
import { Store, Actions } from './store';
import { list, update, exportFun } from '../../service/inventory/inventory';
import { orgList } from '../../service/org';
import { categoryTree } from '../../service/category';
import AdjustModal from './adjustModal';
import { objectSerial } from 'Utils';

class QueryInventory extends Reflux.Component {
  constructor (props) {
    super(props);
    const user = JSON.parse(localStorage.getItem('login_user_information'));
    this.currentOrgId = user.orgId;
    this.defaultIndex = '';
    this.defaultOrgId = null;
    this.defaultOrgType = null;
    this.store = Reflux.initStore(Store); //创建一个Store实例
    this.state = {
      visible: false,
      orgIdIndex: '', //所属组织的列表索引
      orgList: [],
      categoryTree: [],
      currentItem: {},
      rows: [],
      total: 2,
      searchObj: {
        orgId: null,
        orgType: null,
        productName: "",
        categoryId: "",
        storageName: "",
        s: 10,
        p: 1,
      },
      showIndex: '',
    };
    this.exportStyle = { position: 'absolute', bottom: '12px', right: '12px' };
    this.pageChange = this.pageChange.bind(this);
    this.setFilterParam = this.setFilterParam.bind(this);
    this.advanceReset = this.advanceReset.bind(this);
    this.advanceSubmit = this.advanceSubmit.bind(this);
    this.okHandle = this.okHandle.bind(this);
    this.cancelHandle = this.cancelHandle.bind(this);
    this.toggleVisible = this.toggleVisible.bind(this);
    this.setCurrentItem = this.setCurrentItem.bind(this);
    this.toggleBtn = this.toggleBtn.bind(this);
    this.getData = this.getData.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
  }

  //离开当前路由时，更新store
  routeLeaveHook (nextLocation) {
    let path = nextLocation.pathname.split('/');
    if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
      Actions.useStoreChange({ useInventoryStore: true, inventoryIndex: this.state.orgIdIndex });
      Actions.paramChange('inventoryParams', { ...this.state.searchObj });
    } else {
      Actions.useStoreChange({ useInventoryStore: false });
    }
  }

  componentWillMount () { //准备数据
    const self = this;
    const data = this.store.state;
    if (data.useInventoryStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        ...this.state,
        orgIdIndex: data.inventoryIndex,
        searchObj: {
          ...this.state.searchObj,
          ...data.inventoryParams,
        }
      });
    }
    categoryTree().then(res => {
      if (res.status) {
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({ categoryTree: res.data });
          }
        })
      }
    });

    orgList().then(res => { //所属经销商
      if (res.data && res.data.length > 0) {
        const data = res.data.map((x, index) => {
          return {
            ...x,
            value: index + '',
            text: x.name
          }
        });
        let orgIdIndex = data.findIndex(x => x.type === 1);
        orgIdIndex = orgIdIndex === -1 ? null : orgIdIndex;
        self.defaultIndex = orgIdIndex;
        self.defaultOrgId = orgIdIndex !== null ? data[orgIdIndex]['id'] : null;
        self.defaultOrgType =  orgIdIndex !== null ? data[orgIdIndex]['type'] : null;
        if(self.state.orgIdIndex !== '' && self.state.orgIdIndex !== null){
          orgIdIndex = self.state.orgIdIndex;
        }

        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);

            if (orgIdIndex !== null) {
              self.setState({
                ...self.state,
                orgList: data,
                orgIdIndex,
                searchObj: {
                  ...self.state.searchObj,
                  orgId: data[orgIdIndex]['id'],
                  orgType: data[orgIdIndex]['type'],
                }
              });
            } else {
              self.setState({
                ...self.state,
                orgList: data,
                orgIdIndex
              });
            }
          }
        }, 0);
      }
    });
  }

  componentDidMount () {
    this.mounted = true;
    if(this.store.state.useInventoryStore) {
      this.getData();
    }
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  getData () {
    const self = this;
    const { searchObj } = this.state;
    list(searchObj).then(res => {
      self.setState({ total: res.total, rows: res.data });
    });
  }

  goView (url) {
    hashHistory.push(url);
  }

  advanceReset () {
    const self = this;
    this.setState({
      orgIdIndex: this.defaultIndex,
      searchObj: {
        ...this.state.searchObj,
        orgId: this.defaultOrgId,
        orgType: this.defaultOrgType,
        productName: "",
        categoryId: "",
        storageName: "",
        //s: 10,
        p: 1,
      }
    }, function () {
      self.getData();
    })
  };

  advanceSubmit (form) {
    const { orgId } = this.state.searchObj;
    if (!orgId) {
      message.error('所属组织必须设置');
      return null;
    }
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, p: 1 } }, function () {
      self.getData();
    });
  };

  setFilterParam (name, value) {
    // console.log(name + ':\t' + value);
    if (name === 'lastOperationTime') {
      this.setState({
        searchObj: {
          ...this.state.searchObj,
          lastOperationTimeStart: value.from,
          lastOperationTimeEnd: value.end
        }
      })
    } else if (name === 'orgIdIndex') {
      //let index = parseInt(value, 10);//orgList
      let data = this.state.orgList[value] || { orgId: null, orgType: null };//index!==null  ? this.state.orgList[index] : { orgId: null, orgType: null };
      this.setState({ orgIdIndex: value, searchObj: { ...this.state.searchObj, orgId: data.id, orgType: data.type } })
    } else {
      this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
    }
  };

  pageChange (page, pageSize) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
      self.getData();
    })
  }

  toggleVisible () {
    this.setState({ visible: !this.state.visible });
  }

  setCurrentItem (index) {
    let data = { ...this.state.rows[index] };
    this.setState({ currentItem: data });
    this.toggleVisible();
  }

  okHandle (data) {
    const self = this;
    update({ addOrSubtractNum: data.num, remark: data.desc, assignWay: 7, id: this.state.currentItem.id }).then(res => {
      self.toggleVisible();
      self.getData();
    })
  }

  cancelHandle () {
    this.toggleVisible()
  }

  toggleBtn (index) {
    this.setState({ showIndex: index });
  }
  export(){
    const {searchObj, rows, total} = this.state;
    if(!rows.length && !total){
      message.warning('当前没有数据可以导出。请查询后再做操作。');
    } else {
      Modal.confirm({
        title: '操作提示',
        content: '确定按当前查询条件导出数据吗?',
        onOk() {
          window.location.href = `${exportFun}?${objectSerial({...searchObj, s:total})}&exPortType=0&exPortIds=`
        },
        onCancel() {
        },
      });
    }
  }

  render () {
    const { rows, total, searchObj, visible, showIndex, orgList, orgIdIndex, categoryTree, currentItem } = this.state;
    const advanceProps = {
      fileds: [
        {
          name: 'orgIdIndex',
          label: <span><sup style={{ color: '#d61518' }}>*</sup>所属组织</span>,
          text: '输入所属组织',
          type: 'select',
          defaultValue: orgIdIndex + '',
          //dataType: 'number',
          options: orgList,
        },
        {
          name: 'storageName',
          label: '仓库',
          text: '输入仓库',
          defaultValue: searchObj.storageName,
          type: 'default'
        },
        {
          name: 'categoryId',
          label: '产品类别',
          text: '选择产品类别',
          dataType: 'number',
          defaultValue: searchObj.categoryId+'',
          type: 'treeSelect',
          options: categoryTree,
          dropdownStyle:{height:'240px',overflow:'auto'}
        },
        {
          name: 'productName',
          label: '产品名称',
          text: '输入产品名称',
          defaultValue: searchObj.productName,
          type: 'default'
        },
      ],
      handle: this.advanceSubmit,
      reset: this.advanceReset,
      fieldHandle: this.setFilterParam
    };
    const tableViewProps = {
      loading: false,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '产品编码',
          dataIndex: 'productCode',
          render: (text, record, index) => {
            return <a href={`#/product/${record.productId}`}>{text}</a>
          }
        },
        {
          title: '产品名称',
          dataIndex: 'productName',
          width: '200px',
          render: (text, record, index) => {
            return <a href={`#/product/${record.productId}`}>{text}</a>
          }
        }, {
          title: '规格',
          dataIndex: 'specName'
        }, {
          title: '产品类别',
          width: '200px',
          dataIndex: 'categoryText'
        }, {
          title: '单位',
          dataIndex: 'unitText'
        }, {
          title: '仓库',
          dataIndex: 'storageName'
        }, {
          title: '货位',
          dataIndex: 'localCode',
          /*render: (text, record, index) => {
           return <span onMouseOver={this.toggleBtn.bind(this, index)}>{text}</span>
           }*/
        }, {
          title: '库存数量',
          dataIndex: 'storageNum',
          /*render: (text, record, index) => {
           return <span onMouseOver={this.toggleBtn.bind(this, index)}>{text}</span>
           }*/
        }, {
          title: '可用量',
          dataIndex: 'useNum',
          render: (text, record, index) => {
            if (this.currentOrgId === record.orgId) {
              return <span
                onMouseOver={this.toggleBtn.bind(this, index)}
                onMouseOut={this.toggleBtn.bind(this, '')}>
              {text} &nbsp;&nbsp;
                <Button style={{ opacity: showIndex === index ? 1 : 0 }}
                        size={'small'} type="primary" onClick={this.setCurrentItem.bind(this, index)}>调整</Button>
            </span>
            } else {
              return text;
            }
          }
        }
      ],
      rows
    };
    return <div className="dms-body">
      <DmsTab options={['库存查询']} defaultKey={0}/>
      <Row className="dms-table-box" gutter={0}>
        <Col className="gutter-row" span={8}>
          <AdvanceForm {...advanceProps}/>
        </Col>
        <Button onClick={this.export.bind(this)} icon="export" style={this.exportStyle}>导出</Button>
      </Row>
      <div className="dms-table-box">
        <TableView {...tableViewProps}/>
      </div>
      <AdjustModal visible={visible} onCancel={this.cancelHandle} onOk={this.okHandle} data={currentItem}></AdjustModal>
    </div>
  }
}
export default withRouter(QueryInventory);



// WEBPACK FOOTER //
// ./src/routes/inventory/inventory.js